import React from 'react';
import {
  Box, Divider, makeStyles, Typography
} from '@material-ui/core/index';
import useGetRequest from 'src/hooks/useGetRequest';
import {
  RoleAssignment,
  TaskTemplate,
  TaskWithDetailedTriggeredAction,
  TriggeredActionDetail
} from 'src/types';
import FormikSelect from 'src/components/formik/FormikSelect';
import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import FormRenderer from '../../Perspectives/Renderers/FormRenderer';


const useStyles = makeStyles((theme) => ({
  formBox: {
    padding: theme.spacing(2),
    // opacity: 0.8,
    // '&:hover': {
    //   opacity: 1,
    // },
    // transition: theme.transitions.create('opacity', {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen
    // }),
  }
}));


const AssignTaskHandler = ({
  engagementId,
  triggeredAction,
  onSuccess,
  onDismiss,
  // the task to ASSIGN the task
  task,
}: {
  engagementId: string,
  triggeredAction: TriggeredActionDetail,
  onSuccess: (message: string) => void,
  onDismiss: () => void,
  task: TaskWithDetailedTriggeredAction,
}) => {
  const { taskTemplate } = triggeredAction.action;
  const classes = useStyles();
  const {
    result: taskToAssign,
    isLoading: taskIsLoading
  }: {
      result?: TaskWithDetailedTriggeredAction,
      isLoading: boolean
  } = useGetRequest({
    url: (_taskTemplate: TaskTemplate) => `/automatic/engagements/${engagementId}/build-task-from-template/${_taskTemplate.id}/`,
    deps: [taskTemplate]
  });
  const { result: roleAssignments, isLoading }: { result: RoleAssignment[], isLoading: boolean } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/role-assignments/`,
  });

  if (isLoading || taskIsLoading || !taskToAssign) return null;

  const fieldsConfig = [
    {
      name: 'assignedToId',
      component: () => (
        <FormikSelect
          fullWidth
          label="Assigned to"
          name="assignedToId"
          options={roleAssignments.map((ra) => ({
            label: `${ra.account.firstName} ${ra.account.lastName} | ${ra.account.email} | ${ra.role.name}`,
            value: ra.account.id,
          }))}
        />
      ),
      defaultValue: taskToAssign.assignedToId,
    },
  ];

  return (
    <>
      <Box pl={2} pr={2} pb={2} pt={2}>
        <FormRenderer
          formPerspectiveId={taskToAssign.taskTemplate.perspectiveId}
          workflowId={taskToAssign.taskTemplate.workflowId}
          engagementId={taskToAssign.engagementId}
          resourceType="TASKS" // todo - do I need this
          title={taskToAssign.taskTemplate.title}
          taskId={taskToAssign.id}
          closeModal={() => {}}
          onSuccess={() => {}}
          readOnly
        />
      </Box>
      <Box mt={2} mb={2}>
        <Divider />
      </Box>
      <CRUDConfigForm
        url={`/automatic/engagements/${engagementId}/tasks/${task.id}/assign-from-template/`}
        onSuccess={() => onSuccess('Task assigned.')}
        fieldsConfig={fieldsConfig}
        tertiaryButton={{
          label: 'Dismiss',
          onClick: onDismiss,
        }}
      />
    </>
  );
};

export default AssignTaskHandler;
